import type { FunctionComponent, SVGProps } from 'react';

export interface LogoIconProps extends SVGProps<SVGSVGElement> {}

export const LogoIcon: FunctionComponent<LogoIconProps> = ({ viewBox = '0 0 136 27', ...restProps }) => (
    <svg width="136" height="27" viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" {...restProps}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.3668 18.0814H20.2712C19.4151 20.0795 17.6065 21.2223 15.2276 21.2223C12.3718 21.2223 10.9446 19.9848 10.9446 17.0341V7.23123H9.42188V6.56543H13.8952V16.9393C13.8952 18.5568 14.1804 20.0795 16.2741 20.0795C18.9389 20.0795 20.3668 17.5103 20.3668 14.8456V7.23123H18.4634V6.56543H23.3167V20.0795H25.4112V20.8417H20.3668V18.0814Z"
            fill="#001489"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M27.9805 0H32.7397V20.0812H34.8335V20.8433H27.9805V20.0812H29.7891V0.666574H27.9805V0Z" fill="#001489" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.3057 7.23123H37.4971V6.56543H42.2556V20.0795H44.3493V20.8417H37.4971V20.0795H39.3057V7.23123Z"
            fill="#001489"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M57.4849 18.0814H57.3902C56.5332 20.0795 54.7246 21.2223 52.3458 21.2223C49.4907 21.2223 48.0628 19.9848 48.0628 17.0341V7.23123H46.54V6.56543H51.0134V16.9393C51.0134 18.5568 51.3941 20.0795 53.3923 20.0795C56.057 20.0795 57.4849 17.5103 57.4849 14.8456V7.23123H55.5816V6.56543H60.4356V20.0795H62.5293V20.8417H57.4849V18.0814Z"
            fill="#001489"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M89.5577 0.666574H87.5596V0H96.7914C101.169 0 102.121 2.18929 102.121 4.75849C102.121 7.61358 100.218 8.85117 97.6476 9.42219V9.51775C101.264 9.89843 103.738 11.23 103.738 15.2279C103.738 19.7005 100.979 20.8433 96.9818 20.8433H87.5596V20.0812H89.5577V0.666574ZM92.8905 20.081H95.6509C99.3621 20.081 100.219 17.9873 100.219 15.0374C100.219 11.7061 99.077 9.89827 96.1263 9.89827H92.8905V20.081ZM92.8905 8.94835H95.365C97.649 8.94835 98.6963 8.0922 98.6963 5.04677C98.6963 2.66714 98.1253 0.668962 95.5553 0.668962H92.8905V8.94835Z"
            fill="#001489"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M112.59 12.372C113.828 12.0861 114.685 11.8009 115.827 11.4203V10.2775C115.827 8.18373 115.446 6.9469 113.543 6.9469C112.115 6.9469 111.068 7.32758 111.068 9.23098C111.068 10.373 110.687 10.7537 109.64 10.7537C108.879 10.7537 108.308 10.5634 108.308 9.70644C108.308 6.9469 111.163 6.18555 113.447 6.18555C117.921 6.18555 118.777 7.99339 118.777 10.4686V17.8918C118.777 20.0803 119.443 20.0803 121.061 20.0803V20.8425H118.872C117.254 20.8425 116.112 20.6514 115.637 18.9383C114.494 20.6514 113.067 21.2231 111.163 21.2231C108.118 21.2231 107.166 19.6049 107.166 16.9401C107.166 14.5605 108.403 13.4184 110.878 12.8474L112.59 12.372ZM112.97 13.2289C111.162 13.7044 110.591 14.371 110.591 16.9409C110.591 18.654 110.971 20.2723 112.494 20.2723C115.064 20.2723 115.92 17.0357 115.92 15.0376V12.2772L112.97 13.2289Z"
            fill="#001489"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M67.5741 9.1364C67.5741 7.70924 68.6213 7.04267 69.9537 7.04267C72.2378 7.04267 73.0947 8.4706 73.4754 10.1837H74.3315V7.04267C72.9991 6.66199 71.6668 6.18652 70.1441 6.18652C67.5741 6.18652 65.4803 7.70924 65.4803 10.5643C65.4803 15.5132 73.285 14.086 73.285 17.8928C73.285 19.6058 71.572 20.462 70.0493 20.462C67.5741 20.462 66.3373 18.7489 65.9566 16.5604H65.0049V20.2724C66.6224 20.8434 68.3362 21.2241 70.0493 21.2241C72.6185 21.2241 75.5691 19.7006 75.5691 16.7508C75.5691 10.7547 67.5741 12.7536 67.5741 9.1364Z"
            fill="#001489"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M135.432 6.7566C134.861 6.66104 134.289 6.4707 133.433 6.4707C130.958 6.4707 129.245 9.61169 128.388 11.6106H128.293V6.4707H123.249V7.23206H125.343V20.0804H123.439V20.8425H130.197V20.0804H128.293V14.9412C128.293 12.2764 129.626 9.13546 132.386 8.94512C132.957 8.94512 133.909 8.85033 134.861 9.04067L135.432 6.7566Z"
            fill="#001489"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.51985 0H0.285124V0.666574H2.18852V20.9381C2.18852 23.5081 1.80784 25.2211 0.285124 25.6966H0.19034L0 25.7922V26.458H0.475464C0.761358 26.458 1.33238 26.3632 1.6175 26.3632C4.09191 25.7922 5.51985 23.9836 5.51985 21.0329V0Z"
            fill="#001489"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40.7345 0.189453C41.6862 0.189453 42.5432 1.04637 42.5432 1.99806C42.5432 2.94976 41.6862 3.71112 40.7345 3.71112C39.7828 3.71112 39.0215 2.94976 39.0215 1.99806C39.0215 1.04637 39.7828 0.189453 40.7345 0.189453Z"
            fill="#001489"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M110.783 0.189453C111.735 0.189453 112.591 1.04637 112.591 1.99806C112.591 2.94976 111.735 3.71112 110.783 3.71112C109.927 3.71112 109.07 2.94976 109.07 1.99806C109.07 1.04637 109.927 0.189453 110.783 0.189453Z"
            fill="#001489"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M116.683 0.189453C117.54 0.189453 118.396 1.04637 118.396 1.99806C118.396 2.94976 117.54 3.71112 116.683 3.71112C115.731 3.71112 114.875 2.94976 114.875 1.99806C114.875 1.04637 115.731 0.189453 116.683 0.189453Z"
            fill="#001489"
        />
    </svg>
);
